/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import i18next from 'i18next';

import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import Product from '~/modules/ecommerceCoreUI/containers/Product';
import ItemsCardsSlider from '~/modules/ecommerceCoreUI/components/basic/ItemsCardsSlider';
import { LinearLayout } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

const RelatedProductsContainer = styled(LinearLayout)`
  .slick-slider {
    margin: 0 !important;
    .slick-slide > div {
      ${cssMediaMax.mobile`
        margin: 0 !important;
      `};
    }
    > div .slick-track {
      margin-bottom: 0 !important;
      > .slick-slide > div {
        margin: 24px 5px 0 !important;
        ${cssMediaMax.xsmall`
          margin: 24px 0 0 !important;
        `};
      }
    }
    .slick-dots {
      position: relative;
    }
  }
  .ui.container {
    width: 100%;
    ${cssMediaMax.xsmall`
      padding: 0;
    `};
  }
`;

const RelatedProducts = ({ queryResult }) => (
  <RelatedProductsContainer leftAligned>
    {queryResult && queryResult.related_products.length !== 0 && (
      <React.Fragment>
        <Separator separatorLength="full" />
        <Spacer size={[1, 1, 1.5]} />
        <Label primary xxl semiBold>{i18next.t('ecommerceCoreUI:Product.relatedProducts')}</Label>
        <ItemsCardsSlider>
          {queryResult.related_products.map(product => (
            <Product
              isVertical
              productInfo={product}
              key={product.__id}
            />
          ))}
        </ItemsCardsSlider>
      </React.Fragment>
    )}
  </RelatedProductsContainer>
);

RelatedProducts.propTypes = {
  queryResult: PropTypes.shape({}),
};

RelatedProducts.defaultProps = {
  queryResult: null,
};

export default RelatedProducts;
